import React, { Component } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import {
  shortData,
} from '../../helpers';
import CustomTable from '../../components/CustomTable/CustomTable';
import { RowAction, RowActions } from '../../components/RowActions/RowActions';

const columns = [
  {
    id: 'Id', label: 'Id',
  },
  {
    id: 'name', label: 'Plan Name',
  },
  {
    id: 'type', label: 'Loan Type',
  },
  {
    id: 'description',
    label: 'Description',
  },
  {
    id: 'iscompleted', label: 'Completed',
  },
  {
    id: 'action',
    label: 'Action',
  },
];

const useStyles = () => ({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  tablewo: {
    cursor: 'pointer',
    '&:hover': {
      background: '#eeeeee',
    },
  },
  mainContainer: {
    width: '100%',
    minWidth: 0,
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    margin: 20,
  },
  buttonLink: {
    width: 20,
    height: 20,
    margin: 0,
    padding: 10,
  },
});

class SubmittedConstructionPlanTable extends Component {
  render() {
    const {
      classes,
      data,
      page,
      pageCount,
      totalCount,
      rowsPerPage,
      handleChangePage,
      handleChangeRowsPerPage,
      handleShowEditForm,
      handleDeleteData,
      handleShowAddForm,
    } = this.props;

    return (
      <div className={classes.mainContainer}>

        <CustomTable
          showPagination
          icons={[{ icon: AddCircleOutlineRoundedIcon, name: 'Add Config' }]}
          onIconClick={(key) => {
            handleShowAddForm(key);
          }}
          tableName='Construction Plan Configurations'
          tableHead={columns}
          itemComponent={data.length > 0 ? data.map((element, index) => (
            <TableRow
              className={classes.tablewo}
              tabIndex={-1}
              key={element.id}
            >
              <TableCell>
                {(page - 1) * rowsPerPage + index + 1}
              </TableCell>
              <TableCell>
                {shortData(element.planName)}
              </TableCell>
              <TableCell>
                {shortData(element.LoanType.loanType)}
              </TableCell>
              <TableCell>
                {shortData(element.description)}
              </TableCell>
              <TableCell>
                {shortData(element.isCompleted)}
              </TableCell>
              <TableCell>
                <RowActions>
                  <RowAction
                    kind='view'
                    onClick={(key) => { handleShowEditForm(key, element, false); }}
                  />
                  <RowAction
                    kind='edit'
                    onClick={(key) => { handleShowEditForm(key, element, true); }}
                  />
                  <RowAction
                    kind='delete'
                    onClick={(key) => { handleDeleteData(key, element.id); }}
                  />
                </RowActions>
              </TableCell>
            </TableRow>
          )) : null}
          serverSide
          count={pageCount}
          page={page}
          handleChangePage={handleChangePage}
          totalCount={totalCount}
          pageSize={rowsPerPage}
          onPageSizeChange={handleChangeRowsPerPage}
        />
      </div>
    );
  }
}

export default withStyles(useStyles)(SubmittedConstructionPlanTable);
